import { useCallback } from 'react';

type Options = { scrollTo: 'center' | 'start' };

export function useScroll(options: Options = { scrollTo: 'center' }) {
  return useCallback(
    (node: null | HTMLElement) => {
      if (node !== null) {
        node.scrollIntoView({ behavior: 'smooth', block: options.scrollTo });
      }
    },
    [options.scrollTo],
  );
}
